import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useI18n from '@/mixins/useI18n';
import { templateRef } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXCurrencyInput',
  props: {
  value: {
    type: String,
    default: ''
  },
  currencySymbol: {
    type: String,
    default: ''
  },
  decimals: {
    type: Number,
    default: 2
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;




const { locale } = useI18n();



const input = templateRef < HTMLInputElement >('input', null);

const inputValue = computed(() => parseFloat(props.value).toFixed(props.decimals));

const onChange = () => {
  const value = (input.value?.valueAsNumber ?? 0).toFixed(props.decimals);

  emit('input', `${value}`);
};


return { __sfc: true,props, locale, emit, input, inputValue, onChange }
}

})